{
  "nl": {
    "sortGroups": {
      "date": "Datum",
      "deadline": "Deadline",
      "name": "Naam"
    },
    "sorting": {
      "category_name_asc": "Categorie A → Z",
      "category_name_desc": "Categorie Z → A",
      "created_at_asc": "Oudste eerst",
      "created_at_desc": "Nieuwste eerst",
      "deadline_date_asc": "Laatste deadline eerst",
      "deadline_date_desc": "Eerste deadline eerst",
      "due_date asc": "Laatste deadline eerst",
      "due_date desc": "Eerste deadline eerst",
      "group_name asc": "Naam A → Z",
      "group_name desc": "Naam Z → A",
      "group_name_asc": "Naam A → Z",
      "group_name_desc": "Naam Z → A",
      "last_name_asc": "Achternaam A → Z",
      "last_name_desc": "Achternaam Z → A",
      "messaged_all_at_nulls_first_asc": "Oudste eerst",
      "messaged_all_at_nulls_last_desc": "Nieuwste eerst",
      "messaged_at_nulls_first_asc": "Oudste eerst",
      "messaged_at_nulls_last_desc": "Nieuwste eerst",
      "name_asc": "Naam A → Z",
      "name_desc": "Naam Z → A",
      "name_lower asc": "Naam A → Z",
      "name_lower desc": "Naam Z → A",
      "name_lower_asc": "Naam A → Z",
      "name_lower_desc": "Naam Z → A",
      "notification_level_name_asc": "Unit A → Z",
      "notification_level_name_asc_sup": "Project A → Z",
      "notification_level_name_desc": "Unit Z → A",
      "notification_level_name_desc_sup": "Project Z → A",
      "session_started_at_asc": "Oudste sessie eerst",
      "session_started_at_desc": "Nieuwste sessie eerst",
      "status asc": "Status A → Z",
      "status desc": "Status Z → A",
      "status_name_asc": "Status A → Z",
      "status_name_desc": "Status Z → A",
      "unit_name_asc": "Unit A → Z",
      "unit_name_desc": "Unit Z → A",
      "unit_name_lower_asc": "Unit A → Z",
      "unit_name_lower_desc": "Unit Z → A",
      "updated_at asc": "Oudste eerst",
      "updated_at desc": "Nieuwste eerst",
      "updated_at_asc": "Oudste eerst",
      "updated_at_desc": "Nieuwste eerst"
    }
  }
}
